import { BinaryProtocol, ReplicatedGrid } from "./replicated";
import type { Transport } from "../../transport";
import { ArrayCursorStore } from "./store";

export * from "./replicated";
export * from "./store";
export * from "./types";

export const createReplicatedGrid = (options: { channel: Transport<Uint8Array>; name?: string }) =>
  new ReplicatedGrid({ ...options, protocol: new BinaryProtocol(), store: new ArrayCursorStore() });
